import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100 mt-16">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-accent-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">免费在线观看</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200">
              高清影视资源在线观看平台，汇集最新电影、热门电视剧与综艺节目，为你提供便捷的浏览、搜索与筛选体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-nav" className="cursor-pointer">内容分类</a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/category/movie" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">电影</Link></li>
              <li><Link to="/category/tv" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">电视剧</Link></li>
              <li><Link to="/category/variety" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">综艺</Link></li>
              <li><Link to="/search" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">搜索影视</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-topic" className="cursor-pointer">精选专题</a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/topic/deep-night-suspense" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">深夜悬疑特辑</Link></li>
              <li><Link to="/topic/healing-weekend" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">周末治愈片单</Link></li>
              <li><Link to="/topic/epic-scifi" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">史诗科幻专场</Link></li>
              <li><Link to="/topic/family-time" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">全家一起看</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-contact" className="cursor-pointer">关于与联系</a>
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/about" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">免责声明</Link></li>
              <li><span className="text-primary-200">邮箱：hello@example.com</span></li>
              <li><span className="text-primary-200">微博 / 公众号：免费在线观看</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-900 px-4 md:px-6 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
          <p>© {year} 免费在线观看 · 本站所有内容均为演示数据，仅供学习交流使用。</p>
          <p>影视资源信息来自公开渠道，本站不提供任何播放与下载服务。</p>
        </div>
      </div>
    </footer>
  );
}